<form [formGroup]="form">
  <textarea rows="5" formControlName="note"></textarea>
</form>

<button (click)="handleCreate()" class="q-btn--save" translate>
  {{ buttonLabel }}
</button>
